import { Bell } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useNotificationCount } from '../../hooks/usePortal';

/**
 * Notification bell icon with unread badge (AP-13).
 * Renders in the app header; clicking navigates to /notifications.
 * The badge is hidden when unread count is 0.
 */
export default function NotificationBell() {
  const { unread } = useNotificationCount();

  return (
    <Link
      to="/notifications"
      className="iconbtn notifbell"
      aria-label={unread > 0 ? `Notifications — ${unread} unread` : 'Notifications'}
    >
      <Bell size={22} aria-hidden />
      {unread > 0 && (
        <span className="notifbadge" aria-hidden>
          {unread > 99 ? '99+' : unread}
        </span>
      )}
    </Link>
  );
}
